import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import DriverIcon from './DriverIcon';
import PartialIcon from './PartialIcon';
import SubContractorIcon from './SubContractorIcon';
import TrailerIcon from './TrailerIcon';
import VariousResourceIcon from './VariousResourceIcon';
import VehicleResourceIcon from './VehicleResourceIcon';


export const SidebarData = [
    {
        index: 0,
        title: 'Dashboard',
        path: '/dashboard',
        icon: <DashboardCustomizeIcon style={{ color: 'white' }}/>,
        cName: 'nav-text'
    },
    {
        index: 1,
        title: 'Movements',
        path: '/movements',
        icon: <ControlCameraIcon style={{ color: 'white' }} />,
        cName: 'nav-text'
    },
    {
        index: 2,
        title: 'Partial Trips',
        path: '/partialtrip',
        icon: <PartialIcon />,
        cName: 'nav-text'
    },
    // {
    //     index:3,
    //     title: 'Trip Routes',
    //     path: '/route',
    //     icon: <IcoRoute />,
    //     cName: 'nav-text'
    // },
    // {
    //     index:4,
    //     title: 'Shipments Movements',
    //     path: '/shipment-movements',
    //     icon: <ShipmentMoveIcon />,
    //     cName: 'nav-text'
    // },
    // {
    //     index:5,
    //     title: 'Trip',
    //     path: '/trip',
    //     icon: <ModeOfTravelIcon />,
    //     cName: 'nav-text'
    // },
    {
        index: 6,
        title: 'Vehicle Resource',
        path: '/vehicle-resource',
        icon: <VehicleResourceIcon />,
        cName: 'nav-text'
    },
    {
        index: 7,
        title: 'Driver',
        path: '/driver',
        icon: <DriverIcon />,
        cName: 'nav-text'
    },
    {
        index: 8,
        title: 'Subcontractor',
        path: '/subContractor',
        icon: <SubContractorIcon />,
        cName: 'nav-text'
    },
    {
        index: 9,
        title: 'Trailer/Chassis',
        path: '/trailer',
        icon: <TrailerIcon />,
        cName: 'nav-text'
    },
    {
        index: 10,
        title: 'Various Resource',
        path: '/various-resource',
        icon: <VariousResourceIcon />,
        cName: 'nav-text'
    },
    // {
    //     index: 11,
    //     title: 'Resources',
    //     path: '/resources',
    //     icon: <VariousResourceIcon />,
    //     cName: 'nav-text'
    // },
    {
        index: 12,
        title: 'Agenda View',
        path: '/agenda-view',
        icon: <DisplaySettingsIcon style={{ color: 'white' }} />,
        cName: 'nav-text'
    },
    // {
    //     index:7,
    //     title: 'Trip Planning(Partial Trips)',
    //     path: '/partial-trip',
    //     icon: <BallotOutlinedIcon />,
    //     cName: 'nav-text'
    // },
    // {
    //     index: 11,
    //     title: 'Map View',
    //     path: '/map',
    //     icon: <FmdGoodIcon />,
    //     cName: 'nav-text'
    // },   
    // {
    //     index: 13,
    //     title: 'Agenda View2',
    //     path: '/trip-agenda-kendo2',
    //     icon: <RecentActorsOutlinedIcon />,
    //     cName: 'nav-text'
    // },
    // {
    //     index: 14,
    //     title: 'Agenda View DX',
    //     path: '/trip-agenda-dx',
    //     icon: <RecentActorsOutlinedIcon />,
    //     cName: 'nav-text'
    // },
    // {
    //     index: 15,
    //     title: 'Resource View',
    //     path: '/trip-agenda-ms',
    //     icon: <RecentActorsOutlinedIcon />,
    //     cName: 'nav-text'
    // },
    // {
    //     index: 16,
    //     title: 'Agenda View MS PG',
    //     path: '/trip-agenda-ms-pg',
    //     icon: <RecentActorsOutlinedIcon />,
    //     cName: 'nav-text'
    // },
  

]